var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBigBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -1149)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(75 1149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-599.172-1206.826a2.216,2.216,0,0,1-2.1-2.314l.488-8.213h.014c0-.019,0-.038,0-.057a1.263,1.263,0,0,1,.014-.146,1.662,1.662,0,0,1,1.577-1.417,1.668,1.668,0,0,1,1.595,1.621h.007l.495,8.212A2.216,2.216,0,0,1-599.172-1206.826Zm0-13.622a2.158,2.158,0,0,1-2.042-2.254,2.158,2.158,0,0,1,2.042-2.254,2.158,2.158,0,0,1,2.042,2.254A2.158,2.158,0,0,1-599.172-1220.449Z",
    transform: "translate(690.269 2381)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBigBlue);
export default __webpack_public_path__ + "static/media/info-big-blue.557ca11c118602008a6183ef1ac0f04f.svg";
export { ForwardRef as ReactComponent };